import { EnumTypeValue } from "@/shared/types";

export const BETROKKEN_TREINEN_QUERY_KEY = "betrokken-treinen";

export const Uitvoerder = {
    DeWit: "DeWit",
    Transvision: "Transvision",
} as const;

export type Uitvoerder = EnumTypeValue<typeof Uitvoerder>;

export const UitvoerderDisplay = {
    DeWit: "De Wit",
    Transvision: "Transvision",
} as const satisfies Record<Uitvoerder, string>;

export type UitvoerderDisplay = EnumTypeValue<typeof UitvoerderDisplay>;
